import { ApplePayService as ApplePayCoreService } from '@wix/cashier-core/dist/src/services/ApplePay';
import { AuthParams } from '../../types/AuthParams';

/**
 * ApplePay validate merchant
 */
export const validateMerchant = ({ accountId, validationUrl, domain }, auth: AuthParams) => {
  return new ApplePayCoreService(auth)
    .validateMerchant(accountId, {
      validationUrl,
      domain,
    })
    .then((r) => JSON.parse(r.value));
};
